import * as React from "react";
import { Box, TableContainer, TableContainerProps, useTheme, alpha, useMediaQuery, Typography } from "@mui/material";

export interface GlassTableProps extends Omit<TableContainerProps, "sx"> {
  children: React.ReactNode;
  maxHeight?: number | { xs?: number; md?: number; };
  sx?: TableContainerProps["sx"];
  renderMobileList?: () => React.ReactNode;
  mobileListData?: Array<Record<string, any>>; // Optional: provide data for auto list generation
  hasData?: boolean; // Optional: set to false to hide table header when no data
}

const GlassTable = React.forwardRef<HTMLDivElement, GlassTableProps>(
  ({ children, maxHeight = { xs: 420, md: 560 }, sx, renderMobileList, mobileListData, hasData, ...props }, ref) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const maxHeightValue = typeof maxHeight === "number"
      ? maxHeight
      : maxHeight;

    // Conditional rendering: show mobile list if renderMobileList is provided
    // if (isMobile && renderMobileList) {
    //   return (
    //     <Box
    //       ref={ref}
    //       sx={{
    //         position: "relative",
    //         width: "100%",
    //         maxHeight: maxHeightValue,
    //         borderRadius: "18px",
    //         overflow: "hidden",
    //         isolation: "isolate",
    //         background: isDark
    //           ? `linear-gradient(135deg, ${alpha("#0d1b2a", 0.92)} 0%, ${alpha("#0d1b2a", 0.85)} 45%, ${alpha("#12903C", 0.65)} 100%)`
    //           : `linear-gradient(135deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 255, 255, 0.82) 50%, rgba(18, 144, 60, 0.35) 100%)`,
    //         backdropFilter: "blur(24px) saturate(140%)",
    //         WebkitBackdropFilter: "blur(24px) saturate(140%)",
    //         border: `1.5px solid ${isDark ? alpha("#ffffff", 0.4) : alpha("#ffffff", 0.8)}`,
    //         boxShadow: isDark
    //           ? "0 8px 32px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.3)"
    //           : "0 8px 32px rgba(18, 144, 60, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.6)",
    //         "&::before": {
    //           content: '""',
    //           position: "absolute",
    //           top: 0,
    //           left: 0,
    //           right: 0,
    //           bottom: 0,
    //           borderRadius: "18px",
    //           pointerEvents: "none",
    //           boxShadow: isDark
    //             ? "inset 0 1px 0 0 rgba(255, 255, 255, 0.3)"
    //             : "inset 0 1px 0 0 rgba(255, 255, 255, 0.6)",
    //           zIndex: 1,
    //         },
    //         ...sx,
    //       }}
    //     >
    //       {/* Gradient overlays for glass shine effect */}
    //       <Box
    //         sx={{
    //           position: "absolute",
    //           top: 0,
    //           left: 0,
    //           right: 0,
    //           height: "50%",
    //           background: `linear-gradient(180deg, ${alpha("#ffffff", isDark ? 0.15 : 0.25)} 0%, transparent 100%)`,
    //           pointerEvents: "none",
    //           zIndex: 1,
    //           borderRadius: "18px 18px 0 0",
    //         }}
    //       />
    //       <Box
    //         sx={{
    //           position: "absolute",
    //           top: 0,
    //           left: 0,
    //           right: 0,
    //           bottom: 0,
    //           background: `linear-gradient(135deg, transparent 0%, ${alpha("#12903C", 0.03)} 100%)`,
    //           pointerEvents: "none",
    //           zIndex: 1,
    //           borderRadius: "18px",
    //         }}
    //       />
    //       <Box
    //         sx={{
    //           position: "relative",
    //           zIndex: 2,
    //           height: "100%",
    //           maxHeight: maxHeightValue,
    //           overflow: "auto",
    //           p: 2,
    //         }}
    //       >
    //         {renderMobileList()}
    //       </Box>
    //     </Box>
    //   );
    // }

    return (
      <Box
        ref={ref}
        sx={{
          position: "relative",
          width: "100%",
          maxHeight: maxHeightValue,
          borderRadius: "18px",
          overflow: "hidden",
          isolation: "isolate",
          background: isDark
            ? `linear-gradient(135deg, ${alpha("#0d1b2a", 0.92)} 0%, ${alpha("#0d1b2a", 0.85)} 45%, ${alpha("#12903C", 0.65)} 100%)`
            : `linear-gradient(135deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 255, 255, 0.82) 50%, rgba(18, 144, 60, 0.35) 100%)`,
          backdropFilter: "blur(24px) saturate(140%)",
          WebkitBackdropFilter: "blur(24px) saturate(140%)",
          border: `1.5px solid ${isDark ? alpha("#ffffff", 0.4) : alpha("#ffffff", 0.8)}`,
          boxShadow: isDark
            ? "0 8px 32px rgba(0, 0, 0, 0.3), 0 2px 8px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.3)"
            : "0 8px 32px rgba(18, 144, 60, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.6)",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: "18px",
            pointerEvents: "none",
            boxShadow: isDark
              ? "inset 0 1px 0 0 rgba(255, 255, 255, 0.3)"
              : "inset 0 1px 0 0 rgba(255, 255, 255, 0.6)",
            zIndex: 1,
          },
        }}
      >
        {/* Gradient overlays for glass shine effect */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "50%",
            background: `linear-gradient(180deg, ${alpha("#ffffff", isDark ? 0.15 : 0.25)} 0%, transparent 100%)`,
            pointerEvents: "none",
            zIndex: 1,
            borderRadius: "18px 18px 0 0",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `linear-gradient(135deg, transparent 0%, ${alpha("#12903C", 0.03)} 100%)`,
            pointerEvents: "none",
            zIndex: 1,
            borderRadius: "18px",
          }}
        />
        <TableContainer
          {...props}
          sx={{
            width: "100%",
            maxHeight: maxHeightValue,
            borderRadius: "18px",
            overflow: "auto",
            position: "relative",
            zIndex: 2,
            backgroundColor: "transparent",
            // Hide table header (thead) when hasData is false
            "& table thead": {
              display: hasData === false ? "none" : "table-header-group",
            },
            ...sx,
          }}
        >
          {children}
        </TableContainer>
      </Box>
    );
  }
);

GlassTable.displayName = "GlassTable";

export default GlassTable;

